import { EventEmitter } from '@angular/core/src/facade/async';
import { Component, OnInit, Output, Input } from '@angular/core';

@Component({
  selector: 'prg-grid-selector',
  templateUrl: './grid-selector.component.html',
  styleUrls: ['./grid-selector.component.less']
})
export class GridSelectorComponent implements OnInit {

  @Input() title: string;
  @Input() helpText: string;
  @Input() items: Array<any>;
  @Input() nameField: string;
  @Input() subtextField: string;

  @Output() selected: EventEmitter<any>;

  constructor() {
    this.selected = new EventEmitter<any>();
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/advanced/grid-selector/grid-selector.component.ts